import React, { useCallback } from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { LAYOUT_NAME_MAX_LENGTH } from 'const/limits'
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  Button
} from 'react-bootstrap'
import Textarea from 'components/Textarea'

export function CopyLayoutForm ({
  handleSubmit,
  submitting,
}) {
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      event.preventDefault()

      handleSubmit()
    }
  }, [handleSubmit])

  const renderField = useCallback((field) => {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <Textarea
          {...field.input}
          name={null}
          maxLength={LAYOUT_NAME_MAX_LENGTH}
          onKeyDown={handleKeyDown}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }, [handleKeyDown])

  return (
    <form onSubmit={handleSubmit}>
      <Field
        name='name'
        component={renderField}
      />
      <Button type='submit' bsStyle='primary' disabled={submitting}>
        <FormattedMessage id='DESK_COPY_BUTTON' />
      </Button>
    </form>
  )
}

export default reduxForm({
  form: 'copyLayoutForm'
})(CopyLayoutForm)
